export default {
  
  beforeCreate () {
    this.$options._dynamicTextDataDefs = this.$options.computed.dynamicTextData()
    if(this.$options._dynamicTextDataDefs) {
      this.$options.routerLinkedData = this.$options._dynamicTextDataDefs.filter((fd)=>fd.type==='select').map((fd)=>fd.id)
    }
    this.$options.routerLinkedData.push('current_date')
  },
  data () {
    let data = {}
    this.$options._dynamicTextDataDefs.forEach((fd)=>{
      if(fd.type === 'select') data[fd.id] = null
    })
    data.current_date = null
    return data
  },
  computed: {
    currentFilters:{
      get () {
        let filters = {}
        this.$options._dynamicTextDataDefs.forEach((fd)=>{
          if(fd.type === 'select') filters[fd.id] = this[fd.id]
        })
        filters.current_date = this.current_date
        return filters
      },
      set (value) {
        this.$options._dynamicTextDataDefs.forEach((fd)=>{
          if(fd.type === 'select') this[fd.id] = value[fd.id]
        })
      }
    }
  }
}